import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/headphones.vue
var o = {
	name: "DtIconHeadphones",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--headphones"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Headphones",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6 2a4 4 0 0 0-4 4v.5h1A1.5 1.5 0 0 1 4.5 8v1.5A1.5 1.5 0 0 1 3 11h-.5A1.5 1.5 0 0 1 1 9.5V6a5 5 0 1 1 10 0v3.5A1.5 1.5 0 0 1 9.5 11H9a1.5 1.5 0 0 1-1.5-1.5V8A1.5 1.5 0 0 1 9 6.5h1V6a4 4 0 0 0-4-4Zm4 5.5H9a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-2Zm-8 2a.5.5 0 0 0 .5.5H3a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H2v2Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=headphones.js.map